import { AssignmentV3Document } from '@/store/v2';
/* eslint-disable import/no-unused-modules */
import { ApolloError, useQuery } from '@apollo/client';

import { AssignmentV3QueryResult } from '@/store/assignments/types';
import { transformResults } from '@/store/assignments/shared/utils';
import { AssignmentWithStatus } from './types';

type UseBaseAssignmentHook = (query: { assignmentId: number | undefined; userId: number | undefined }) => {
  data: AssignmentWithStatus | undefined;
  loading: boolean;
  error: ApolloError | undefined;
};

type QueryResult = { learner: AssignmentV3QueryResult['assignmentV3'] };

export const useBaseAssignment: UseBaseAssignmentHook = ({ assignmentId, userId }) => {
  const { data, loading, error } = useQuery<QueryResult>(AssignmentV3Document, {
    variables: {
      selectLearner: true,
      id: assignmentId,
      userIdIN: [userId],
    },
    skip: !assignmentId || !userId,
  });

  const userIds = userId ? [userId] : [];

  return {
    data: data ? transformResults(data.learner, userIds) : undefined,
    loading,
    error,
  };
};
